import Image from 'next/image';
import * as Accordion from '@radix-ui/react-accordion';
import { Text, Flex, Icon, Button } from '@pairy/pds-react';

import { TriggerChevronIcon } from '@/styles/Accordion/ViewHistoryAccordion.styles';
import { logo } from '@/components/User/_components/pdf/BulkLogos/index.constants';

import * as Styled from '../../index.styles';
import useCopy from '../../useCopy';

const Totle = () => {
  const copy = useCopy();

  return (
    <>
      <Accordion.Header>
        <Styled.AccordionTrigger>
          <Image
            src={logo.totle.src}
            alt={logo.totle.alt}
            width={logo.totle.width}
            height={logo.totle.height}
          />
          <TriggerChevronIcon icon="ph:caret-up" size={19} />
        </Styled.AccordionTrigger>
      </Accordion.Header>
      <Styled.AccordionContent>
        <Styled.Ol>
          <Styled.Li>
            <Text variant="md-medium">
              메일 보낼 고객을 outlook 연락처에 등록하기
            </Text>
          </Styled.Li>
          <Styled.Li>
            <Text variant="md-medium">발송옵션 → 매크로 발송 을 선택하기</Text>
          </Styled.Li>
          <Styled.Li>
            <Flex as="button" onClick={() => copy('totle')}>
              <Icon icon="ph:link" size={17} color="skyblue_400" />
              <Text
                as="p"
                variant="md-medium"
                color="skyblue_400"
                marginLeft={4}
              >
                totle용 링크
                <Text variant="md-medium" marginLeft={4}>
                  메일 본문에 붙여넣기
                </Text>
              </Text>
            </Flex>
          </Styled.Li>
        </Styled.Ol>
        <Button
          type="button"
          width="100%"
          variant="skyblue_300"
          textVariant="md-medium"
          radius={8}
          paddingX={16}
          paddingY={12}
          InnerWrappeGap={4}
          marginTop={16}
          leftIcon={<Icon icon="ph:link" size={17} />}
          onClick={() => copy('totle')}
        >
          totle용 링크 생성하기
        </Button>
      </Styled.AccordionContent>
    </>
  );
};

export default Totle;
